import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c87c07d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-hfe" }
const _hoisted_2 = { class: "nge-hfe-head" }
const _hoisted_3 = {
  class: "nge-hfe-ways",
  role: "radiogroup",
  "aria-label": "Where the places come from"
}
const _hoisted_4 = ["aria-checked", "disabled"]
const _hoisted_5 = ["aria-checked", "disabled"]
const _hoisted_6 = { class: "nge-hfe-help" }
const _hoisted_7 = {
  key: 1,
  class: "nge-hfe-help"
}
const _hoisted_8 = {
  key: 2,
  class: "nge-hfe-row"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["disabled", "onKeydown"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 4,
  class: "nge-hfe-muted"
}
const _hoisted_14 = {
  key: 5,
  class: "nge-hfe-busy",
  role: "status"
}
const _hoisted_15 = {
  key: 6,
  class: "nge-hfe-error",
  role: "alert"
}
const _hoisted_16 = {
  key: 0,
  class: "nge-hfe-muted"
}
const _hoisted_17 = {
  key: 1,
  class: "nge-hfe-muted"
}
const _hoisted_18 = {
  key: 2,
  class: "nge-hfe-warn"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-hfe-label" }, "Players start from the cell as it was", -1 /* HOISTED */))
const _hoisted_20 = {
  class: "nge-hfe-sessions",
  role: "radiogroup",
  "aria-label": "When players start from"
}
const _hoisted_21 = ["aria-checked", "disabled", "onClick"]
const _hoisted_22 = { class: "nge-hfe-session-count" }
const _hoisted_23 = { class: "nge-hfe-session-after" }
const _hoisted_24 = {
  key: 0,
  class: "nge-hfe-muted"
}
const _hoisted_25 = {
  key: 1,
  class: "nge-hfe-check"
}
const _hoisted_26 = ["checked"]
const _hoisted_27 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString($setup.fromEdits.buildId ? 'From the cell players helped build' : 'Or make it from a proofread cell'), 1 /* TEXT */),
    ($setup.fromEdits.buildId)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              role: "radio",
              class: _normalizeClass(["nge-hfe-session", { 'nge-hfe-session--on': $setup.built }]),
              "aria-checked": $setup.built,
              disabled: !!$setup.busy || !$setup.plantedCount,
              onClick: _cache[0] || (_cache[0] = $event => ($setup.fromBuilt('planted')))
            }, "Planted errors (" + _toDisplayString($setup.plantedCount) + ")", 11 /* TEXT, CLASS, PROPS */, _hoisted_4),
            _createElementVNode("button", {
              type: "button",
              role: "radio",
              class: _normalizeClass(["nge-hfe-session", { 'nge-hfe-session--on': !!$setup.history && !$setup.built }]),
              "aria-checked": !!$setup.history && !$setup.built,
              disabled: !!$setup.busy,
              onClick: _cache[1] || (_cache[1] = $event => ($setup.fromBuilt('proofreading')))
            }, "The proofreaders' edits", 10 /* CLASS, PROPS */, _hoisted_5)
          ]),
          _createElementVNode("p", _hoisted_6, _toDisplayString($setup.built
        ? 'Each planting, reversed: a merge you planted is a merger to Cut, a cut a piece to Extend. Players start from the cell as it is now.'
        : 'Each cut the proofreaders made is a merger to find, each join an extension. Players start from the cell as it was before the edits you pick; the proofread cell stays hidden from players until the Hunt ends.') + " Saving ties the cell to this Hunt.", 1 /* TEXT */)
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock("p", _hoisted_7, "Paste a cell from the proofread list. Each cut the proofreaders made becomes a merger to find, each join an extension. Players start from the cell as it was before the edits you pick, so check every place in the viewer first.")),
    (!$setup.fromEdits.buildId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.fromEdits.dataset) = $event)),
            class: "nge-hfe-input nge-hfe-ds",
            "aria-label": "Dataset",
            disabled: !!$setup.busy
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.HISTORY_SOURCES, (s) => {
              return (_openBlock(), _createElementBlock("option", {
                key: s.canon,
                value: s.canon
              }, _toDisplayString(s.label), 9 /* TEXT, PROPS */, _hoisted_10))
            }), 128 /* KEYED_FRAGMENT */))
          ], 8 /* PROPS */, _hoisted_9), [
            [_vModelSelect, $setup.fromEdits.dataset]
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.fromEdits.root) = $event)),
            class: "nge-hfe-input nge-hfe-root",
            placeholder: "864691136814060915",
            "aria-label": "Proofread cell ID",
            disabled: !!$setup.busy,
            onKeydown: _withKeys($setup.find, ["enter"])
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_11), [
            [_vModelText, $setup.fromEdits.root]
          ]),
          _createElementVNode("button", {
            class: "nge-hfe-btn",
            disabled: !!$setup.busy || !$setup.fromEdits.root.trim(),
            onClick: $setup.find
          }, "Find the edits", 8 /* PROPS */, _hoisted_12)
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.fromEdits.buildId && !$setup.history && !$setup.busy)
      ? (_openBlock(), _createElementBlock("button", {
          key: 3,
          class: "nge-hfe-btn",
          onClick: _cache[4] || (_cache[4] = $event => ($setup.fromBuilt()))
        }, "Read the Hunt cell again"))
      : _createCommentVNode("v-if", true),
    (!$setup.onDataset && !$setup.history && !$setup.fromEdits.buildId)
      ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Opening it switches to " + _toDisplayString($setup.sourceFor($setup.fromEdits.dataset)?.label) + ".", 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    ($setup.busy)
      ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString($setup.busy) + "…", 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    ($setup.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString($setup.error), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    ($setup.history)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
          ($setup.built)
            ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                _createTextVNode("Hunt cell "),
                _createElementVNode("code", null, _toDisplayString($setup.history.root), 1 /* TEXT */),
                _createTextVNode(": " + _toDisplayString($setup.kindsLine($setup.history.sessions[0]?.places ?? [])) + " planted.", 1 /* TEXT */)
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_17, [
                _createTextVNode(_toDisplayString($setup.history.source.label) + ", proofread", 1 /* TEXT */),
                ($setup.history.status)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(": " + _toDisplayString($setup.history.status), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
                _createTextVNode(". " + _toDisplayString($setup.count($setup.history.cellEdits, 'edit', 'edits')) + " on the cell itself, " + _toDisplayString($setup.history.totalEdits) + " in its whole history.", 1 /* TEXT */)
              ])),
          (!$setup.history.reaches)
            ? (_openBlock(), _createElementBlock("p", _hoisted_18, "The cell's edits did not lead all the way to this ID, so some may be missing. Check the places by hand."))
            : _createCommentVNode("v-if", true),
          (!$setup.built)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.history.sessions, (s, i) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: s.at,
                      type: "button",
                      role: "radio",
                      "aria-checked": i === $setup.fromEdits.pick,
                      class: _normalizeClass(["nge-hfe-session", { 'nge-hfe-session--on': i === $setup.fromEdits.pick, 'nge-hfe-session--empty': !s.places.length }]),
                      disabled: !!$setup.busy,
                      onClick: $event => ($setup.choose(i))
                    }, [
                      _createElementVNode("span", null, "Before " + _toDisplayString($setup.day(s.at)), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_22, _toDisplayString($setup.kindsLine(s.places)), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_23, _toDisplayString($setup.count(s.editsAfter, 'edit', 'edits')) + " after", 1 /* TEXT */)
                    ], 10 /* CLASS, PROPS */, _hoisted_21))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          ($setup.session)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createVNode($setup["HuntPlacesList"]),
                ($setup.droppedLine)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString($setup.droppedLine), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (!$setup.built)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_25, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: $setup.fromEdits.finished,
                        onChange: $setup.finished
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_26),
                      _createTextVNode(" Show the finished cell (only you see it)")
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("button", {
                  class: "nge-hfe-btn nge-hfe-btn--look",
                  disabled: !!$setup.busy,
                  onClick: _cache[5] || (_cache[5] = $event => ($setup.emit('check')))
                }, "Check them in the viewer", 8 /* PROPS */, _hoisted_27)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}